const color = {
    blue : '#7FB5FF',
    babyBlue : '#C4DDFF',
    darkBlue: '#1d3557',
    grayBlue: '#457b9d',
    lightBlue: '#a8dadc',
    green: '#008000',
    ivory: '#fbfefb',
    red: '#d22227',
    lightgray: '#e7e7e7',
    darkgray: '#555555',
    gray: '#999',
    white: '#fefefe',
    beige: '#FEE2C5',
    yellow: '#FFd90f',
    aquaBlue: '#26bfbf',
    black: '#000000',
    lavender: '#E6E6FA',
    ghost: '#F8F8FF',
    lightRed: '#ffb09c',
}

export default color;
